var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"orders-scheduler-activities"},[_c('base-table',{ref:"baseTable",staticClass:"activities-table",attrs:{"service":_vm.$options.maintenanceTaskService,"fetch-func":"generatedOrders","fetch-params":{
      contract_id: _vm.contract || undefined,
      includes: 'scheduledLog,operations,operations.activityCode',
    },"columns":_vm.columns,"sticky":""},on:{"fetch":function (data) { return _vm.$emit('fetch', data); }},scopedSlots:_vm._u([{key:"rowId",fn:function(ref){
    var row = ref.row;
return [_c('b-button',{staticClass:"generated-order-id",attrs:{"type":"is-text"},on:{"click":function () { return _vm.viewOrder(row); }}},[_vm._v("\n        "+_vm._s(row.id)+"\n      ")])]}},{key:"rowOperations",fn:function(ref){
    var row = ref.row;
return [_vm._v("\n      "+_vm._s((row.operations || []).length)+"\n    ")]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2cb41fa8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/OrdersScheduler/activities/index.vue
// module id = null
// module chunks = 